import React, { useState } from 'react'

import Link from 'images/inline/editorial/link.svg'

import { CopyLinkModal } from 'components/modal/submodals/CopyLinkModal'
import './LinkShare.scss'

const LinkShare = ({ url, clickHandler = function () {} }) => {
  const [copyLinkOpen, setCopyLinkOpen] = useState(false)

  const openCopyLinkModal = () => {
    clickHandler()
    setCopyLinkOpen(true)
  }

  return (
    <>
      <button
        aria-label="Link Copied"
        onClick={openCopyLinkModal}
        onKeyUp={e => {
          if (e.key === 'Enter') {
            openCopyLinkModal()
          }
        }}
        className="link-share"
        tabIndex={0}
      >
        <Link />
      </button>
      <CopyLinkModal
        open={copyLinkOpen}
        handleClose={() => setCopyLinkOpen(false)}
        shareUrl={url}
      />
    </>
  )
}

export default LinkShare
